import { useEffect, useRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Conteneur scrollable pour le thread de messages agent.
 * Auto-scroll en bas dès que `scrollKey` change (typiquement messages.length).
 */
export function AgentThread({
  children,
  scrollKey,
  className,
  maxHeight = 600,
}: {
  children: ReactNode;
  scrollKey?: number | string;
  className?: string;
  maxHeight?: number;
}) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    ref.current?.scrollTo({
      top: ref.current.scrollHeight,
      behavior: "smooth",
    });
  }, [scrollKey]);

  return (
    <div
      ref={ref}
      className={cn("flex flex-col gap-3 overflow-y-auto", className)}
      style={{ maxHeight }}
    >
      {children}
    </div>
  );
}
